// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-o_fS","advertDetailHeaderPrice__value":"c-o_fT","advertDetailHeaderPrice__label":"c-o_fU"};